let lastScrollY = window.pageYOffset;
const menu = document.querySelector(".header__mega-menu");
const annbar = document.querySelector(".shopify-section--topbar") || null;
let annbarHeight = 0;
let isAnnbar = false;

if (annbar && annbar.children.length > 0) {
  isAnnbar = true;
  annbarHeight = annbar.clientHeight;
  console.log(annbarHeight);
}

window.addEventListener("scroll", () => {
  const currentScrollY = window.pageYOffset;
  const isScrollingDown = currentScrollY > lastScrollY;

  if (isScrollingDown) {
    menu.classList.add("hidden");
    if (isAnnbar) {
      annbar.classList.add("hidden");
    }
  } else {
    menu.classList.remove("hidden");
    if (isAnnbar) {
      annbar.classList.remove("hidden");
      annbar.style.top = "0px";
    }

    const topbarHidden = annbar?.querySelector(".topbar--hidden");
    menu.style.top = topbarHidden ? "0px" : `${annbarHeight}px`;
  }

  lastScrollY = currentScrollY;
});
